import React, { Component } from 'react'
import _ from 'underscore'
import { Clearfix, Image, ProgressBar } from 'react-bootstrap'
import { createElement, createStatusElement } from './base'
import { Avatar, Left, Right, Icon, Html, Download, Preview } from '../../ui'
import { mixinsClassName, dateUtil, mapFileType, substrByBytes } from '../../utils'

export default class extends Component {
    render() {
        const { data, onPreview, onReSend } = this.props
        let { body, is_received } = data;
        let className = mixinsClassName(is_received ? "left" : "right", this.props, "msg-" + body.type)
        let dateText = dateUtil(data.created_at).shortFormat()
        let avatarEl = <Avatar src={data.avatar} text={data.nick_name} className="online" width={24} height={24}/>
        let LeftEl;
        let RightEl;
        let HeadingEl;
        let ContentEl;
        let filebarEl;
        let StatusEl;

        if (is_received) {
            LeftEl = avatarEl;
            HeadingEl = `${data.nick_name} ${dateText}`;
        } else {
            RightEl = avatarEl;
            HeadingEl = `${dateText} ${data.nick_name}`;
        }
        filebarEl = <div title={body.file_name}>{ substrByBytes(body.file_name, 20) } ({ body.file_size })</div>;
        if (data.status) {
            StatusEl = createStatusElement(data, { onClick: onReSend && onReSend.bind(null, data) });
        }

        switch (body.type) {
            case "image":
                ContentEl = (
                    <Image src={body.file_src} rounded onClick={onPreview&&onPreview.bind(null, data)} />
                )
                break;
            case "file":
                ContentEl = (
                    <div>
                      <Left>
                        <Icon iconClass={mapFileType(body.file_ext)} />
                      </Left>
                      <Right className="mgl-xs">
                        { filebarEl }
                        <Clearfix className="mgt-xxs">
                          <Left>
                            <Download href={body.file_src} file_name={body.file_name}/>
                          </Left>
                          <Right>
                            <Preview href={body.file_src} file_ext={body.file_ext} storage_policy={body.storage_policy}/>
                          </Right>
                        </Clearfix>
                      </Right>
                    </div>
                )
                break;
            case "uploading":
                ContentEl = (
                    <div>
                      { filebarEl }
                      <ProgressBar className="mgt-xxs" now={parseFloat(body.percentage)} label={body.percentage+'%'} active/>
                    </div>
                )
                break;
            case "text":
                ContentEl = <Html value={body.content} useSafe={true}/>
                break;
            case "html":
                ContentEl = <Html value={body.content} />
                break;
            default:
                ContentEl = <p>{body.content}</p>
                break;
        }

        return createElement({
            props: { className: className },
            Left: LeftEl,
            Right: RightEl,
            Heading: HeadingEl,
            Content: ContentEl,
            Status: StatusEl
        })
    }
}


// WEBPACK FOOTER //
// ./src/msg/item/index.js